var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlaidShield = function SvgPlaidShield(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3338 1.00024C15.3338 1.00024 10.7159 4.88223 5.43319 4.88223V7.62132C5.43319 7.62132 5.1193 20.9897 15.3338 25C15.3338 25 25.3723 21.9283 25.3723 7.62132V4.88223C20.0478 4.88223 15.3338 1.00024 15.3338 1.00024Z",
    fill: "#F7FAF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3335 1V24.9997C15.3335 24.9997 25.372 21.9281 25.372 7.62107V4.88199C20.0475 4.88199 15.3335 1 15.3335 1Z",
    fill: "#EDF8F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1235 3.3837C19.8894 4.31307 22.2857 5.2606 24.8723 5.37146V7.62132C24.8723 14.6436 22.4143 18.8625 19.9962 21.3255C18.7822 22.5621 17.5694 23.3648 16.6635 23.8572C16.2108 24.1033 15.8355 24.2714 15.5763 24.3771C15.4845 24.4145 15.4073 24.4441 15.3465 24.4665C10.5512 22.5099 8.19175 18.3828 7.03039 14.658C6.44391 12.777 6.16912 11.0156 6.04131 9.72357C5.97748 9.07824 5.95048 8.55181 5.93942 8.18836C5.93389 8.00668 5.93234 7.86587 5.93215 7.77145C5.93206 7.72424 5.93231 7.68864 5.93257 7.66534L5.93292 7.63971L5.93303 7.63398L5.93305 7.63306L5.93319 7.63306V7.62132V5.37129C8.4985 5.25959 10.862 4.31171 12.6003 3.38215C13.5294 2.8853 14.2894 2.38854 14.8181 2.01526C15.0286 1.86661 15.2028 1.73731 15.3368 1.63506C15.4737 1.73765 15.6524 1.86786 15.8687 2.01776C16.4069 2.39077 17.18 2.88719 18.1235 3.3837Z",
    stroke: "#1A1E22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7764 12.5182L14.5819 15.3755L19.5329 10.0551",
    stroke: "#3D7C54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98163 3.46902V5.42155",
    stroke: "#007AFF",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.44522H2.96226",
    stroke: "#007AFF",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73264 1V2.37851",
    stroke: "#FFBE00",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03906 1.68875H5.42445",
    stroke: "#FFBE00",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9883 21.8097L25.9998 21.8097",
    stroke: "#6ED9C6",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9941 20.809L24.9941 22.8105",
    stroke: "#6ED9C6",
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlaidShield);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "plaid-shield.f0bbc64751710fbb5959ecfa9f843d53.svg";